const selectors = [
  '.header-navigation a',
  '.hamburger-overlay a',
  '.footer-navigation a',
  '.footer-main-navigation a',
  '.profile-nav-desktop a',
  '.profile-nav-mobile a',
];
const currentUrl = window.location.origin + window.location.pathname;

/**
 * Give a link and match the first one who's active
 * @param item
 */
const matchActiveNavItems = (item: HTMLAnchorElement) => {
  const currentPath = new URL(currentUrl).pathname;
  const itemPath = new URL(item.href).pathname;

  if (itemPath === '/' && currentPath !== '/') {
    return;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, '');
  const normalizedItemPath = itemPath.replace(/\/$/, '');

  const isExactMatch = normalizedCurrentPath === normalizedItemPath;

  if (!isExactMatch) {
    return;
  }

  item.classList.add('active');
  item.ariaCurrent = 'page';
};

/**
 * Loop over all base-matched elements
 */
export const activeNavigation = () => {
  document.querySelectorAll(selectors.join(', ')).forEach((item) => {
    matchActiveNavItems(item as HTMLAnchorElement);
  });
};
